/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PencilIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAA9UlEQVR4nOWUPQrCQBCFcwBrSxUPYmGpzsyuEGcIOYJ/la05hxfRJm0uISJewjYyQVGESOJmC/HBNFt8b/fNY4PgrwUkCyQ+geHDaBp1G4Zzgkbyl7mMp1G/ETjibPAGLwaMnIm452xgbdxWWJnJ13EByQaJU72lTpkJEu+dMod7FB9Mjl/DsYIJGJ47wfGtOZNJ2NG63s+2TcHz15fo4rVdjcLxudS0Mrg23Eiu7fIGx3qZy7rezTmpDA/DsAUkVy9wFVgZeonlIbSy9AZXAfHOG1yFxJk3uEo/qJKOX9HwKnAVGIkLE+KsiMvKUhev7XKG/7RuU4F3RTa5fHwAAAAASUVORK5CYII=)
 */
export const PencilIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m13.96 5.46 4.58 4.58a1 1 0 0 0 1.42 0l1.38-1.38a2 2 0 0 0 0-2.82l-3.18-3.18a2 2 0 0 0-2.82 0l-1.38 1.38a1 1 0 0 0 0 1.42ZM2.11 20.16l.73-4.22a3 3 0 0 1 .83-1.61l7.87-7.87a1 1 0 0 1 1.42 0l4.58 4.58a1 1 0 0 1 0 1.42l-7.87 7.87a3 3 0 0 1-1.6.83l-4.23.73a1.5 1.5 0 0 1-1.73-1.73Z"
        className={colorClass}
      />
    </svg>
  );
};
